import { alertSuccess } from '../api'

export const copyValueToClipboard = value => {
  navigator.clipboard.writeText(value).then(() => alertSuccess('Copied'))
}
